<template>

  <div class="demo-app" :class="{ active: this.demoActive == true }">
    <!-- <pre> {{schedulingList}}</pre>  -->

    <div class="flex items-start w-full">

      <div class="demo-app-main">
        <vs-card>
          <!-- <pre>{{arg}}</pre>  -->
          <FullCalendar
            class="demo-app-calendar"
            :options="calendarOptions"
            ref="calendar"


          >
            <!-- Hello -->
            <template v-slot:eventContent="arg">
              <div class="w-full" v-if="arg">
                <vs-tooltip :text="`Holiday From ${arg.event.start} to ${arg.event.end}`">
                 
                  <div class="event-card">
                  
                    <div class="flex items-center">
                      <div
                        class="indicator"
                        :style="{ backgroundColor: arg.event.backgroundColor }"
                      ></div>
                      <!-- <feather-icon icon="ClockIcon" /> -->
                      <!-- <feather-icon icon="UserIcon" /> -->
                     <!--  <b class="limitTitle"
                      
                        ><i>{{ arg.event.start }}</i></b
                      > -->
                     <span v-html="arg.event.extendedProps.description"></span>
                    </div>
                  </div>
                </vs-tooltip>
              </div>
            </template>
          </FullCalendar>
        </vs-card>
      </div>
    </div>
    <!-- edit modal -->
    <div v-if="eachEventInfo">

      <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-show="eachEventPopUp" :class="{show: eachEventPopUp}">
        <div class="cstm-modal">
          <div class="header" :style="{'background-color': eachEventInfo.backgroundColor}">
            <h3>General Info</h3>
            <button @click="eachEventPopUp = false" class="close-modal">&times;</button>
          </div>
          <!-- <pre>{{eachEventInfo.backgroundColor}}</pre> -->
          
          <div class="p-4 modal-content">
            <general-event-detail :eachEventInfo="eachEventInfo"
            @editingEvent="editingEvent"
            @eventEmitDeleted="eventEmitDeleted"
            ></general-event-detail>
          </div>
        </div>
      </div>
    </div>

    <!-- adding event modal -->
    <div v-if="eventAdding">
      <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-show="eventAdding" :class="{show: eventAdding}">
        <div class="cstm-modal">
          <div class="header">
            <h3 v-if="editingObject">Edit Event</h3>
            <h3 v-else>Add Event</h3>
            <button @click="eventAdding = false" class="close-modal">&times;</button>
          </div>
          <!-- <pre>{{eachEventInfo.backgroundColor}}</pre> -->
          
          <div class="p-4 modal-content">
            <add-event
              @saveEventEmit="saveEventEmit"
              :startDate="startDate"
              :endDate="endDate"
              :editingObject="editingObject"
            ></add-event>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
// import { INITIAL_EVENTS, createEventId } from './event-utils'
import ListPlugin from '@fullcalendar/list'
import Datepicker from 'vuejs-datepicker'
import AddEvent from './AddEvent'

import GeneralEventDetail from './GeneralEventDetail'
import Editor from '@tinymce/tinymce-vue'
import { eventMixin } from '../mixins/eventMixin'
import moment from 'moment'

import Vue from 'vue'
Vue.prototype.moment = moment

export default {
  
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    AddEvent,
    Datepicker,
    GeneralEventDetail,
    editor: Editor
  },
  mixins: [eventMixin],
  props: {
    name: {
      type: String,
      required: true,
      eachEventPopUp: false
    }
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
    // this.fetchingTeacherList()
    this.fetchingEvent(null, 'general')

  },
  mounted () {
    this.calendarApi = this.$refs.calendar.getApi()
    
    
    //this.$refs.calendar.getApi().prev()
    
    
    // 
    // 
    /**/
    // 

    /*    const moreElement = document.getElementsByClassName('fc-daygrid-more-link')
    

    moreElement[0].addEventListener('click', event => {
      event.stopPropagation() 
      
      // 
               
    }) */

    //inserting Component // Very 
    /*  const vuecomp = Vue.extend(Testing)
    const component = new vuecomp().$mount()
    
    // this.$refs.calendar.$el.firstChild.append(component.$el)


    this.$refs.calendar.$el.firstChild.parentNode.insertBefore(component.$el, this.$refs.calendar.$el.firstChild.nextSibling) */


    //inserting component//
  },
  data () {
    return {
      editingObject:null,
      search: 'sad',
      event: null,
      startDate:null,
      endDate:null,
      eachEventPopUp: false,
      eventAdding: false,
      title: '',
      picked: 1,
      // radios1: [],
      eachEventInfo:null,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          ListPlugin // needed for dateClick
        ],
        /*      validRange (nowDate) {
          return {
            start: nowDate
          } 
        }, */
        customButtons: {
          previousButton: {
            text: '<',
            click:() => { this.previousMonth('general') }
           
          },
          nextButton: {
            text: '>',
            click:() => { this.nextMonth('general') }

          },
          todayButton: {
            text: 'Today',
            click:() => { this.today('general') }

          }
        },
        headerToolbar: {
          left: 'previousButton,nextButton todayButton',
          center: 'title',
          right: 'dayGridMonth'
        },
        eventLimit: false, // for all non-TimeGrid views
        events:[],
        initialView: 'dayGridMonth',
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        eventTimeFormat: { // like '14:30'
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false
        },
        // INITIAL_EVENTS:this.events,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        eventDrop:(info) => { this.eventDrop(info) },
        eventResize :(info) => { this.eventResizeInfo(info) }
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      currentEvents: [],
      demoActive: false,
      schedulingList:[],
      eachMonthEventData:[],
      calendarApi:'',
      allTeachers:true
    }
  },
  methods: {
    editingEvent (id) {
      setTimeout(() => {
        this.eachEventPopUp = false
        const value = this.schedulingList.find(ele => ele.id == id)
        this.editingObject = {...value}
        
        this.eventAdding = true
      }, 0)
      
      /*  
      const obj this.eachMonthEventData.filter(ele => {
        return ele.id === id
      }) */
     
    },
    eventEmitDeleted (id) {
      setTimeout(() => {
        const event = this.calendarApi.getEventById(id)
            
        event.remove()
        this.eachEventPopUp = false
      }, 0)


    },
    eventDrop (info) {
      
      
    },
    eventResizeInfo  (info) {
      // 
      
    },
   
    handleWeekendsToggle () {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
    },
    handleDateSelect (selectInfo) {

      
     
      /* const today = moment(new Date())
      const selectedDate = moment(new Date(selectInfo.startStr))
      const differenceDate = today.diff(selectedDate, 'days') */

      const checkingDateToday = this.validateTodayDate(new Date(), new Date(selectInfo.startStr))
       
      if (checkingDateToday <= 0) {
        
        this.startDate = selectInfo.startStr
        this.endDate = selectInfo.endStr
        // 
        this.eventAdding = true
      } else {
       
        this.showSuccessMessage('Error', 'Event can not be scheduled on a past date', 'danger')
      }
    },
    handleEventClick (clickInfo) {
      
      this.eachEventInfo = clickInfo.event
      this.eachEventPopUp = true
    },
    handleEvents (events) {
      this.currentEvents = events
    },
    openMenubar () {
      this.demoActive = !this.demoActive
    },
    saveEventEmit () {
      this.showSuccessMessage('Success', 'Holiday Added Successfully', 'success') 
      setTimeout(() => {
        this.eventAdding = false
        
      }, 0)
      const payload = this.creatingPayload('general')
      this.fetchingEvent(payload, 'general')
    }
  },
  watch:{
    eventAdding () {
      if (this.eventAdding === false) {
        this.editingObject = null
        
      }
    }
  }
}
</script>

<style lang='css'>
h2 {
  margin: 0;
  font-size: 16px;
}
/* ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}
li {
  margin: 1.5em 0;
  padding: 0;
} */
b {
  /* used for event dates/times */
  /* margin-right: 3px; */
}
.fc {
  /* the calendar root */
  max-width: 100%;
}
.childInherit {
  width: inherit;
}

.teacher-info {
  display: inherit;
  min-width: 50%;
  border: 1px solid #eee;
  padding: 10px;
}
.bg-light-grey {
  background: #f3f3f3;
  padding: 5px;
  margin: 0 5px;
  border-radius: 5px;
}
.tox-tinymce-aux {
  z-index: 100000 !important;
}

/* .name-list img {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 1;
} */
.event-card {
  border-radius: 4px;
  /* background-color: #41ccdf; 
  color: #fff; 
  border-width: 3px 0 0 0; 
  border-style: solid; 
  border-color: transparent; */
}
/* .fc-event-today {
  border: none;
  background-color: transparent;
}
.fc-event-today .event-card {
  background-color: #ccc;
}
.fc-event-today .indicator {
  display: none;
} */
.event-card .feather-icon {
  width: 12px;
  margin-right: 2px;
}
.event-card .limitTitle {
  display: inline-block;
  width: calc(100% - 45px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.indicator {
  width: 7px;
  height: 7px;
  margin-right: 3px;
  border-radius: 50%;
}

/* td.fc-daygrid-day {
  height: 200px;
} */

@media (max-width: 480px) {
  .teacher-info {
    min-width: 100%;
  }
}
</style>

